import React, { useEffect, useState } from 'react';
import ReportsTable from './ReportsTable';
import { Row, Col, Container } from 'react-bootstrap';
import { listDiscoverJobsPage, transformDiscoverJobsToReportRows } from 'DataDiscovery/discoverApi';

const Reports = () => {
  const [fetchingData, setFetchingData] = useState(false);
  const [resultSets, setResultSets] = useState([]);
  const [error, setError] = useState(null);

  const PAGE_SIZE = 10;
  const FETCH_SIZE = 200;

  const loadSearchResultsHandler = async () => {
    setFetchingData(true);
    setError(null);
    try {
      let page = 0;
      let totalPages = 1;
      const allJobs = [];
      while (page < totalPages) {
        const { pageDto, discoverJobs } = await listDiscoverJobsPage(page, FETCH_SIZE, 'startedAt,desc');
        allJobs.push(...discoverJobs);
        totalPages = pageDto && pageDto.totalPages != null ? Number(pageDto.totalPages) : 1;
        page += 1;
      }
      const resultsValue = transformDiscoverJobsToReportRows(allJobs, 0);
      setResultSets(resultsValue);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setResultSets([]);
    }
    setFetchingData(false);
  };

  useEffect(() => {
    loadSearchResultsHandler(0);
  }, []);

  return (
    <div>
      <Container fluid className='p-0'>
        <h5 className='text-left mb-3 sg-eyebrow'>DISCOVERY RESULTS</h5>
        {error && (
          <Row className='widget-row'>
            <Col>
              <div className='text-danger p-2'>{error}</div>
            </Col>
          </Row>
        )}
        <Row className='widget-row'>
          <Col>
            <ReportsTable
              resultSets={resultSets}
              pageSize={PAGE_SIZE}
              fetchingData={fetchingData}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Reports;
